import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCastle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCastle"><Path d="M8.5 5.0625H9.75V3H14.25V5.0625H15.5V3H20V5.78809L21.0537 21H14V15.5H10V21H2.94629L4 5.78809V3H8.5V5.0625Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCastle;
